/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Playdata_Home_Sample_CtaInputs */

const ja_playdata_home_sample_cta = /** @type {(inputs: Playdata_Home_Sample_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`無料サンプルをダウンロード`)
};

const en_playdata_home_sample_cta = /** @type {(inputs: Playdata_Home_Sample_CtaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Download Free Sample`)
};

/**
* | output |
* | --- |
* | "Download Free Sample" |
*
* @param {Playdata_Home_Sample_CtaInputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
export const playdata_home_sample_cta = /** @type {((inputs?: Playdata_Home_Sample_CtaInputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Playdata_Home_Sample_CtaInputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_playdata_home_sample_cta(inputs)
	return en_playdata_home_sample_cta(inputs)
});